import { NavItem, NavSection, openSections } from '@core/auth/section-access';
import { SubmenuLink } from '@core/services/breadcrumb.service';

const SECTION_DETAILS: Readonly<Record<NavSection, Pick<NavItem, 'label' | 'icon'>>> = {
  dashboard: { label: 'Dashboard', icon: 'dashboard' },
  products: { label: 'Products', icon: 'products' },
  postingProfiles: { label: 'Posting Profiles', icon: 'posting-profiles' },
  marketplaces: { label: 'Marketplaces', icon: 'marketplaces' },
  listings: { label: 'Listings', icon: 'listings' },
  customers: { label: 'Customers', icon: null }
};

const SECTION_BY_SEGMENT = new Map<string, NavSection>([
  ['', 'dashboard'],
  ['dashboard', 'dashboard'],
  ['products', 'products'],
  ['posting-profiles', 'postingProfiles'],
  ['marketplaces', 'marketplaces'],
  ['listings', 'listings'],
  ['customers', 'customers']
]);

/** The sections the granted permissions open, in menu order; a section with sub-pages keeps only the permitted ones. */
export function buildNavItems(
  granted: ReadonlySet<string>,
  submenus: Readonly<Record<string, SubmenuLink[]>>
): NavItem[] {
  return openSections(granted, submenus).map(section => ({ ...section, ...SECTION_DETAILS[section.section] }));
}

/** The section a URL belongs to, or null for a URL outside the menu. */
export function sectionForUrl(url: string): NavSection | null {
  const segment = url.split(/[?#]/)[0].split('/')[1] ?? '';
  return SECTION_BY_SEGMENT.get(segment) ?? null;
}
